import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class InvalidVisitorEndTimeError extends CodedError {
  static get errorName() {
    return errorCodes.invalidVisitorEndTimeError.code;
  }

  constructor(message: string = errorCodes.invalidVisitorEndTimeError.message) {
    super(message);
    this.code = errorCodes.invalidVisitorEndTimeError.code;
    this.message = `${message} ${errorCodes.invalidVisitorEndTimeError.code}`;
    this.name = errorCodes.invalidVisitorEndTimeError.name;
  }
}
